import { BaseDto } from '../base.dto';

export class GiftCardEmailLogDto extends BaseDto {
  giftCardId: number;
  receivingEmail: string;
  emailStatus: string;
  eventDate: Date;
  templateId: number;
  messageId: string;
  emailType?: {
    name: string;
  };
}
